export const InstructorPermissionKeys = Object.freeze({
  LIST: {
    VIEW: 'product.instructor.list-view',
    UPDATE: 'product.instructor.list-update',
    DELETE: 'product.instructor.list-delete',
  },
});
